/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import _ from 'lodash';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Chip,
  TableContainer,
  Paper,
  Box,
  Modal,
  Typography,
  CircularProgress,
  Tooltip,
  Checkbox,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import { DownloadOutlined } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import CopyToClipboardButton from 'renderer/shared/components/CopyToClipboardButton';
import { useGetProductByPriceIdQuery } from 'renderer/features/products-page/services/products.endpoints';
import HostAppsDropdown from 'renderer/features/purchase-page/components/HostAppsDropdown';
import { Form, Formik } from 'formik';
import { useStripe } from '@stripe/react-stripe-js';
import { confirmStripePayment } from 'renderer/shared/payments/confirmStripePayment';
import {
  useCreatePaypalCheckoutMutation,
  useCreatePaypalCaptureMutation,
} from 'renderer/features/purchase-page/services/purchase.endpoints';
import { useGetCartQuery } from 'renderer/features/payments-page/services/cart.endpoints';
import {
  useUpdateLicenseUsableMutation,
  usePreviewSubscriptionChangeQuery,
  useUpgradeSubscriptionMutation,
  useDowngradeSubscriptionMutation,
  useCancelSubscriptionMutation,
  useReleaseScheduleMutation,
  useFinalizePaypalUpgradeMutation,
  useFinalizeStripeUpgradeMutation,
} from '../services/users.endpoints';
import {
  Subscription as SubscriptionType,
  Subscriptions as SubscriptionsType,
} from '../schemas/users.schemas';
import InvoiceDetails from './InvoiceDetails';
import SubscriptionKeyDetails from './SubscriptionKeyDetails';

const getChipColor = (subscription: SubscriptionType) => {
  if (subscription.status === 'canceled') return 'error.main';
  if (subscription.status === 'pending') return 'warning.light';
  if (subscription.scheduledChange === 'cancel') return 'error.main';
  if (subscription.scheduledChange === 'downgrade') return 'warning.light';
  return 'success.main';
};

const formatBillingDate = (subscription: SubscriptionType) =>
  moment(subscription.billingPeriodEndDate).format('MM/DD/YY');

const labelStatusChip = (subscription: SubscriptionType) => {
  if (subscription.status === 'canceled') {
    return `Canceled\n${formatBillingDate(subscription)}`;
  }
  if (subscription.status !== 'canceled' && !!subscription.scheduledChange) {
    return `${_.capitalize(subscription.scheduledChange)}s\n${formatBillingDate(
      subscription,
    )}`;
  }
  return `Renews \n${formatBillingDate(subscription)}`;
};

const tableStyles = {
  tableContainer: {
    marginBottom: '20px',
    border: '1px solid rgba(224, 224, 224, 1)',
  },
  table: {
    minWidth: 650,
  },
  tableHead: {
    backgroundColor: '#f5f5f5',
  },
  tableCell: {
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
  tableRow: {
    '&:last-child td': {
      border: 0,
    },
  },
};

interface SubscriptionsProps {
  subscriptions: SubscriptionsType;
  userId: string;
  refetchUserDetails: () => void;
  isAdmin: boolean;
}

export default function Subscriptions({
  subscriptions,
  userId,
  refetchUserDetails,
  isAdmin,
}: SubscriptionsProps) {
  const theme = useTheme();
  const { data: cartData, refetch: refetchCart } = useGetCartQuery(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [serialModalOpen, setSerialModalOpen] = useState(false);
  const [serialDetails, setSerialDetails] = useState<
    SubscriptionType | undefined
  >(undefined);
  const [previewDetails, setPreviewDetails] = useState<any>('');
  const [currentSubscription, setCurrentSubscription] = useState<any>(null);
  const [subscriptionIdToRemove, setSubscriptionIdToRemove] =
    useState<string>('');

  const [upgradeSubscription] = useUpgradeSubscriptionMutation();
  const [finalizeStripeUpgrade] = useFinalizeStripeUpgradeMutation();
  const [downgradeSubscription] = useDowngradeSubscriptionMutation();
  const [cancelSubscription] = useCancelSubscriptionMutation();
  const [updateLicenseUsable] = useUpdateLicenseUsableMutation();
  const stripe = useStripe();
  const { data: newProduct } = useGetProductByPriceIdQuery(
    currentSubscription ? currentSubscription.newPlanId : '',
  );

  const initialForm = {
    hostApplication:
      newProduct &&
      newProduct.supportedHostApplications &&
      newProduct.supportedHostApplications.length === 1
        ? newProduct.supportedHostApplications[0]
        : {
            id: '',
            version: '',
            displayName: '',
          },
  };

  const handleCheckboxChange = async (event: any, serial: string) => {
    const { checked } = event.target;
    try {
      await updateLicenseUsable({
        serial,
        status: checked,
        userId,
        isAdmin,
      }).unwrap();
      refetchUserDetails();
    } catch (error) {
      console.error('Failed to update license group:', error);
    }
  };
  const [finalizePaypalUpgrade] = useFinalizePaypalUpgradeMutation();
  const [createPaypalCheckout] = useCreatePaypalCheckoutMutation();
  const [createPaypalCapture] = useCreatePaypalCaptureMutation();
  const isWide = useMediaQuery('(min-width:1400px)');

  const [fetchData, setFetchData] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState<string | null>(null);
  const [action, setAction] = useState<string | null>(null);
  const [newPlanId, setNewPlanId] = useState<string | null>(null);

  const [confirmLoading, setConfirmLoading] = useState(false);

  const [hoveredSubscriptionId, setHoveredSubscriptionId] = useState<
    string | null
  >(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [scheduledChange, setScheduledChange] = useState<string | undefined>(
    '',
  );

  const [releaseSchedule] = useReleaseScheduleMutation();
  const handleRemoveScheduledUpdate = async (subId: string) => {
    try {
      await releaseSchedule(subId);
      setShowConfirmModal(false);
    } catch (error) {
      console.error('Error removing scheduled change:', error);
    }
  };

  const openConfirmModal = (
    _subscriptionId: string,
    changeType: string | undefined,
  ) => {
    setSubscriptionIdToRemove(_subscriptionId);
    setScheduledChange(changeType);
    setShowConfirmModal(true);
  };

  const { data, error, isLoading } = usePreviewSubscriptionChangeQuery({
    subscriptionId,
    action,
    newPlanId,
    enabled: fetchData,
  });

  useEffect(() => {
    if (fetchData && !isLoading) {
      if (data) {
        setPreviewDetails(<InvoiceDetails data={data} />);
        setModalOpen(true);
      }
      if (error) {
        setPreviewDetails(`Failed to fetch details: ${(error as any).message}`);
        setModalOpen(true);
      }
      setFetchData(false);
    }
  }, [data, error, isLoading, fetchData]);

  // 🔹 Capture PayPal redirect on Dashboard load
  // useEffect(() => {
  //   // debugger
  //   const params = new URLSearchParams(window.location.search);
  //   if (params.get('paypalReturn')) {
  //     console.log('capture useEffect')
  //     const id = params.get('subscription_id') || params.get('token');
  //     const upgrade = params.get('upgrade');
  //     const subscriptionIdParam = params.get('subscriptionId') || undefined;
  //     const planId = params.get('planId') || undefined;

  //     if (id) {
  //       createPaypalCapture({
  //         id,
  //         type: 'subscription',
  //         subscriptionId: subscriptionIdParam,
  //         newPlanId: planId,
  //       })
  //         .unwrap()
  //         .then(() => {
  //           refetchUserDetails();
  //           refetchCart();
  //         })
  //         .catch((err) =>
  //           console.error('Failed to capture PayPal checkout:', err),
  //         )
  //         .finally(() => {
  //           // clean up query params
  //           const url = new URL(window.location.href);
  //           url.search = '';
  //           window.history.replaceState({}, '', url.toString());
  //         });
  //     }
  //   }
  // }, [createPaypalCapture, refetchUserDetails, refetchCart]);

  // useEffect(() => {
  //   const { hash } = window.location;
  //   const queryIndex = hash.indexOf('?');
  //   if (queryIndex > -1) {
  //     const queryString = hash.substring(queryIndex + 1);
  //     const params = new URLSearchParams(queryString);

  //     if (params.get('paypalReturn')) {
  //       console.log('capture useEffect');

  //       const id = params.get('subscription_id') || params.get('token');
  //       const upgrade = params.get('upgrade');
  //       const subscriptionIdParam = params.get('subscriptionId') || undefined;
  //       const planId = params.get('planId') || undefined;

  //       if (id) {
  //         createPaypalCapture({
  //           id,
  //           type: 'subscription',
  //           subscriptionId: subscriptionIdParam,
  //           newPlanId: planId,
  //         })
  //           .unwrap()
  //           .then(() => {
  //             refetchUserDetails();
  //             refetchCart();
  //           })
  //           .catch((err) =>
  //             console.error('Failed to capture PayPal checkout:', err),
  //           )
  //           .finally(() => {
  //             // clean up query params
  //             const url = new URL(window.location.href);
  //             url.hash = '#/dashboard'; // strip query but keep route
  //             window.history.replaceState({}, '', url.toString());
  //           });
  //       }
  //     }
  //   }
  // }, [createPaypalCapture, refetchUserDetails, refetchCart]);

  // useEffect(() => {
  //   const { hash } = window.location;
  //   const queryIndex = hash.indexOf('?');
  //   if (queryIndex > -1) {
  //     const queryString = hash.substring(queryIndex + 1);
  //     const params = new URLSearchParams(queryString);

  //     if (params.get('paypalReturn')) {
  //       console.log('➡️ Handling PayPal return');

  //       const id = params.get('subscription_id') || params.get('token'); // can be Order ID or Subscription ID
  //       const upgrade = params.get('upgrade'); // signals an upgrade flow
  //       const subscriptionIdParam = params.get('subscriptionId') || undefined;
  //       const planId = params.get('planId') || undefined;

  //       if (id) {
  //         if (upgrade && subscriptionIdParam && planId) {
  //           // 🔹 Subscription Upgrade Flow → finalize upgrade
  //           finalizePaypalUpgrade({
  //             oldSubscriptionId: subscriptionIdParam,
  //             newPlanId: planId,
  //             prorationOrderId: id, // PayPal Order ID
  //           })
  //             .unwrap()
  //             .then(() => {
  //               refetchUserDetails();
  //               refetchCart();
  //             })
  //             .catch((err) =>
  //               console.error('❌ Failed to finalize PayPal upgrade:', err),
  //             )
  //             .finally(() => {
  //               const url = new URL(window.location.href);
  //               url.hash = '#/dashboard';
  //               window.history.replaceState({}, '', url.toString());
  //             });
  //         } else {
  //           // 🔹 Regular Checkout / One-time purchase flow
  //           createPaypalCapture({
  //             id,
  //             type: 'subscription',
  //             subscriptionId: subscriptionIdParam,
  //             newPlanId: planId,
  //           })
  //             .unwrap()
  //             .then(() => {
  //               refetchUserDetails();
  //               refetchCart();
  //             })
  //             .catch((err) =>
  //               console.error('❌ Failed to capture PayPal checkout:', err),
  //             )
  //             .finally(() => {
  //               const url = new URL(window.location.href);
  //               url.hash = '#/dashboard';
  //               window.history.replaceState({}, '', url.toString());
  //             });
  //         }
  //       }
  //     }
  //   }
  // }, [
  //   createPaypalCapture,
  //   refetchUserDetails,
  //   refetchCart,
  //   finalizePaypalUpgrade,
  // ]);

  useEffect(() => {
    const { hash } = window.location;
    const queryIndex = hash.indexOf('?');
    if (queryIndex > -1) {
      const queryString = hash.substring(queryIndex + 1);
      const params = new URLSearchParams(queryString);

      if (params.get('paypalReturn')) {
        const id = params.get('subscription_id') || params.get('token'); // PayPal returns the Order token/ID
        const upgrade = params.get('upgrade');
        const subscriptionIdParam = params.get('subscriptionId') || undefined;
        const planId = params.get('planId') || undefined;

        if (id && upgrade && subscriptionIdParam && planId) {
          // 🔹 finalize proration+revise on the server
          finalizePaypalUpgrade({
            oldSubscriptionId: subscriptionIdParam,
            newPlanId: planId,
            prorationOrderId: id,
          })
            .unwrap()
            .then(() => {
              refetchUserDetails();
              refetchCart();
            })
            .catch((err) =>
              console.error('Failed to finalize PayPal upgrade:', err),
            )
            .finally(() => {
              const url = new URL(window.location.href);
              url.hash = '#/dashboard';
              window.history.replaceState({}, '', url.toString());
            });
        }
      }
    }
  }, [finalizePaypalUpgrade, refetchUserDetails, refetchCart]);

  const handlePreview = async (
    _subscriptionId: string,
    _action: string,
    _newPlanId: string | null,
  ) => {
    const subscription = subscriptions.find((s) => s._id === _subscriptionId);

    setCurrentSubscription({
      subscriptionId: _subscriptionId,
      action: _action,
      newPlanId: _newPlanId,
      isPaypal: Boolean(subscription?.paypalId),
      cartId: cartData?.id,
    });

    setSubscriptionId(_subscriptionId);
    setAction(_action);
    setNewPlanId(_newPlanId);

    if (_action === 'downgrade' || _action === 'cancel') {
      setPreviewDetails(
        'Changes will take effect at the end of your current billing period.',
      );
    } else {
      setFetchData(true);
    }

    setModalOpen(true);
  };

  const handleConfirm = async (values: typeof initialForm) => {
    if (!currentSubscription) return;
    setConfirmLoading(true);
    setPreviewDetails(<CircularProgress size={70} thickness={5} />);
    switch (currentSubscription.action) {
      // case 'upgrade':
      //   if (currentSubscription.isPaypal) {
      //     const { approvals } = await createPaypalCheckout({
      //       user: { id: userId },
      //       billingAddress: {},
      //       purchases: [
      //         {
      //           subscriptionId: currentSubscription.subscriptionId,
      //           newPlanId: currentSubscription.newPlanId,
      //         },
      //       ],
      //       returnUrl: `${window.location.origin}/#/dashboard?paypalReturn=true&upgrade=true&subscriptionId=${currentSubscription.subscriptionId}&planId=${currentSubscription.newPlanId}`,
      //       cancelUrl: `${window.location.origin}/#/purchase/cancel`,
      //     }).unwrap();
      //     const [approval] = approvals;
      //     const { approvalUrl } = approval;
      //     if (approval) {
      //       window.location.href = approvalUrl;
      //     }
      //   } else {
      //     await upgradeSubscription({
      //       subscriptionId: currentSubscription.subscriptionId,
      //       newPlanId: currentSubscription.newPlanId,
      //       hostApplication:
      //         newProduct?.supportedHostApplications?.length === 1
      //           ? newProduct.supportedHostApplications[0]
      //           : values.hostApplication,
      //     });
      //   }
      //   break;
      case 'upgrade':
        if (currentSubscription.isPaypal) {
          // call your upgrade endpoint (controller returns {approvalUrl, orderId, newPlanId} for proration)
          const res = await upgradeSubscription({
            subscriptionId: currentSubscription.subscriptionId,
            newPlanId: currentSubscription.newPlanId,
            hostApplication:
              newProduct?.supportedHostApplications?.length === 1
                ? newProduct.supportedHostApplications[0]
                : values.hostApplication,
          }).unwrap();

          if (res?.approvalUrl) {
            // Keep the ids we need in the URL (FE uses them after approval)
            const url = new URL(res.approvalUrl);
            url.searchParams.set('paypalReturn', 'true');
            url.searchParams.set('upgrade', 'true');
            url.searchParams.set(
              'subscriptionId',
              currentSubscription.subscriptionId,
            );
            url.searchParams.set('planId', currentSubscription.newPlanId);
            // For Orders approval links, we can’t append params to PayPal’s domain,
            // so put them on the hash of our returnUrl instead:
            window.location.href = res.approvalUrl;
          } else {
            // no approval step (tiny proration) → backend already revised
            refetchUserDetails();
            refetchCart();
          }
        } else {
          const hostApplication =
            newProduct?.supportedHostApplications?.length === 1
              ? newProduct.supportedHostApplications[0]
              : values.hostApplication;

          const res = await upgradeSubscription({
            subscriptionId: currentSubscription.subscriptionId,
            newPlanId: currentSubscription.newPlanId,
            hostApplication,
          }).unwrap();

          if (res?.type === 'requires_action') {
            if (!stripe) {
              throw new Error('Stripe is not initialized');
            }
            await confirmStripePayment(stripe, res.clientSecret);
            await finalizeStripeUpgrade({
              subscriptionId: currentSubscription.subscriptionId,
              newPlanId: currentSubscription.newPlanId,
              hostApplication,
              paymentIntentId: res.paymentIntentId,
            }).unwrap();
          }

          refetchUserDetails();
          refetchCart();
        }
        break;
      case 'downgrade':
        await downgradeSubscription({
          subscriptionId: currentSubscription.subscriptionId,
          newPlanId: currentSubscription.newPlanId,
          hostApplication: values.hostApplication,
        });
        break;
      case 'cancel':
        await cancelSubscription(currentSubscription.subscriptionId);
        break;
      default:
        break;
    }
    setConfirmLoading(false);
    setModalOpen(false);
  };

  return (
    <>
      <SubscriptionKeyDetails
        open={serialModalOpen}
        handleClose={() => setSerialModalOpen(false)}
        subscription={serialDetails}
      />
      <TableContainer component={Paper} sx={tableStyles.tableContainer}>
        <Table sx={tableStyles.table} aria-label="licenses table" size="small">
          <TableHead sx={tableStyles.tableHead}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>PRODUCT</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>
                SUBSCRIPTION KEY
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                STATUS
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                USEABLE BY THIS ACCOUNT
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="center">
                ACTIONS
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {subscriptions.map((subscription) => (
              <TableRow
                key={subscription._id}
                sx={{
                  '&:last-child td': { border: 0 },
                  '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
                }}
                onMouseEnter={() => setHoveredSubscriptionId(subscription._id)}
                onMouseLeave={() => setHoveredSubscriptionId(null)}
              >
                <TableCell>
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 0.5,
                    }}
                  >
                    {`${subscription.name}${
                      subscription.hostApp ? `(${subscription.hostApp})` : ''
                    }`}
                    <Tooltip title="Download" placement="top">
                      <IconButton
                        component="a"
                        href="https://digitalanarchy.com/subscriptions/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Download"
                        size="small"
                      >
                        <DownloadOutlined
                          style={{ color: theme.palette.grey[900] }}
                        />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Button
                      onClick={() => {
                        setSerialModalOpen(true);
                        setSerialDetails(subscription);
                      }}
                    >
                      {subscription.serial}{' '}
                    </Button>
                    <CopyToClipboardButton textToCopy={subscription.serial} />
                  </Box>
                </TableCell>
                <TableCell
                  align={subscription.scheduledChange ? 'left' : 'center'}
                >
                  {subscription.scheduledChange && subscription.isOwner ? (
                    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                      <Chip
                        label={labelStatusChip(subscription)}
                        color="error"
                        onDelete={() =>
                          openConfirmModal(
                            subscription._id,
                            subscription.scheduledChange,
                          )
                        }
                        deleteIcon={
                          <Tooltip
                            title={`Remove scheduled ${subscription.scheduledChange}`}
                          >
                            <CloseIcon />
                          </Tooltip>
                        }
                        sx={{
                          ml: 1,
                          borderRadius: 1,
                          height: 'auto',
                          p: 0.5,
                          backgroundColor: getChipColor(subscription),
                          width: 150,
                          textAlign: 'center',
                          '& .MuiChip-label': {
                            display: 'block',
                            whiteSpace: 'normal',
                          },
                          fontWeight: 'bold',
                        }}
                      />
                    </Box>
                  ) : (
                    <Chip
                      sx={{
                        backgroundColor: getChipColor(subscription),
                        color: 'common.white',
                        ml: 1,
                        p: 0.5,
                        borderRadius: 1,
                        fontWeight: 'bold',
                        height: 'auto',
                        width: 150,
                        textAlign: 'center',
                        '& .MuiChip-label': {
                          display: 'block',
                          whiteSpace: 'pre-line',
                        },
                      }}
                      label={labelStatusChip(subscription)}
                    />
                  )}
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    checked={subscription.isUsable}
                    disabled={
                      !subscription.isOwner ||
                      subscription.status === 'canceled'
                    }
                    onChange={(e) =>
                      handleCheckboxChange(e, subscription.serial)
                    }
                  />
                </TableCell>
                <Tooltip
                  title={
                    subscription.isOwner
                      ? 'Manage Subscription'
                      : 'Contact License Owner'
                  }
                >
                  <TableCell align="center">
                    <Box
                      sx={
                        isWide ? { display: 'flex', flexDirection: 'row' } : {}
                      }
                    >
                      {subscription.upgradeId &&
                        !subscription.scheduledChange && (
                          <Button
                            size="small"
                            sx={{ mr: 1 }}
                            variant="contained"
                            onClick={() =>
                              handlePreview(
                                subscription._id,
                                'upgrade',
                                subscription.upgradeId
                                  ? subscription.upgradeId ?? null
                                  : null,
                              )
                            }
                            disabled={
                              confirmLoading ||
                              !subscription.isOwner ||
                              subscription.status === 'canceled'
                            }
                          >
                            Upgrade
                          </Button>
                        )}
                      {subscription.downgradeId &&
                        !subscription.scheduledChange && (
                          <Button
                            size="small"
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={() =>
                              handlePreview(
                                subscription._id,
                                'downgrade',
                                subscription.downgradeId
                                  ? subscription.downgradeId ?? null
                                  : null,
                              )
                            }
                            disabled={
                              !subscription.downgradeId ||
                              confirmLoading ||
                              !!subscription.scheduledChange ||
                              !subscription.isOwner ||
                              subscription.status === 'canceled'
                            }
                          >
                            Downgrade
                          </Button>
                        )}
                      <Button
                        size="small"
                        color="error"
                        variant="outlined"
                        sx={{
                          bgcolor: 'lightred',
                          '&:hover': { bgcolor: 'red', color: 'white' },
                          mr: 1,
                        }}
                        onClick={() =>
                          handlePreview(subscription._id, 'cancel', null)
                        }
                        disabled={
                          confirmLoading ||
                          subscription.scheduledChange === 'cancel' ||
                          !subscription.isOwner ||
                          subscription.status === 'canceled'
                        }
                      >
                        Cancel
                      </Button>
                    </Box>
                  </TableCell>
                </Tooltip>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Confirm remove scheduled modal */}
      <Modal open={showConfirmModal} onClose={() => setShowConfirmModal(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6">Confirm</Typography>
          <Typography sx={{ mt: 2 }}>
            Are you sure you want to remove update to {scheduledChange} the
            plan?
          </Typography>
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
            <Button onClick={() => setShowConfirmModal(false)}>Cancel</Button>
            <Button
              variant="contained"
              color="error"
              onClick={() =>
                handleRemoveScheduledUpdate(subscriptionIdToRemove)
              }
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Preview/Confirm modal */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Formik
          initialValues={initialForm}
          onSubmit={(values) => handleConfirm(values)}
        >
          <Form>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '200px',
              }}
            >
              <Typography variant="h6" sx={{ mb: 2 }}>
                Subscription Change {!confirmLoading ? 'Preview' : ''}
              </Typography>
              {newProduct && currentSubscription?.action === 'downgrade' && (
                <HostAppsDropdown
                  supportedHostApplications={
                    newProduct.supportedHostApplications
                  }
                />
              )}
              {isLoading || confirmLoading ? (
                <CircularProgress size={70} thickness={5} />
              ) : (
                <>
                  <Typography sx={{ flexGrow: 1 }}>{previewDetails}</Typography>
                  <Box
                    sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}
                  >
                    <Button
                      sx={{ mr: 2 }}
                      variant="contained"
                      type="submit"
                      disabled={confirmLoading}
                    >
                      Confirm
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => setModalOpen(false)}
                    >
                      Close
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          </Form>
        </Formik>
      </Modal>
    </>
  );
}
